      console.log("GG Giftlist JS loaded ✅");
      /* =========================================================
   HELPERS
========================================================= */

function formatOccasionName(name) {
  if (!name) return "";

  if (name.includes("’s") || name.includes("'s")) return name;

  return name.replace(/s(\s|$)/, "’s$1");
}
      
      /* Good Gifts – Gift List (Phase 1: guest/localStorage) */

      (function () {
      const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M";
      const SUPABASE_URL = "https://uxqpmqluozqnytnqhnwt.supabase.co";

      // ===== Occasion list storage (each occasion gets its own list) =====
      const STORAGE_KEY_PREFIX = "gg_giftlist_v1__";

      window.ggGetActiveOccasionName = function () {
        return (localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas").trim();
      };
      function ggListKeyForOccasion(name) {
        return STORAGE_KEY_PREFIX + String(name || "My Gift Ideas").trim();
      }
        function readList() {
        try {
          const key = ggListKeyForOccasion(ggGetActiveOccasionName());
          const raw = localStorage.getItem(key);
          return raw ? JSON.parse(raw) : [];
        } catch (e) {
          return [];
        }
      }

        function writeList(items) {
        const key = ggListKeyForOccasion(ggGetActiveOccasionName());
        localStorage.setItem(key, JSON.stringify(items));
      }

      function isInList(id) {
        try {
          const prefix = STORAGE_KEY_PREFIX;

          for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (!key || !key.startsWith(prefix)) continue;

            const raw = localStorage.getItem(key);
            if (!raw) continue;

            const items = JSON.parse(raw);
            if (!Array.isArray(items)) continue;

            if (items.some((x) => String(x.id) === String(id))) {
              return true;
            }
          }
        } catch (e) {
          console.warn("Good Gifts: failed to check saved heart state", e);
        }

        return false;
      }

        function addItem(item) {
          const items = readList();
          if (!items.some((x) => String(x.id) === String(item.id))) {
            items.unshift(item);
            writeList(items);
          }
        }

        function removeItem(id) {
        const items = readList().filter(x => String(x.id) !== String(id));
        writeList(items);
        if (window.saveListToCustomer) {
  window.saveListToCustomer();
}

        const activeOccasion = localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas";
        if (typeof ggToast === "function") {
          ggToast(`Removed from ${activeOccasion}`, "success");
        }
      }

        function toggleItem(item) {
          if (isInList(item.id)) {
            removeItem(item.id);
            return false;
          } else {
            addItem(item);
            return true;
          }
        }

      function updateAllHeartStates() {
        document.querySelectorAll("[data-gg-heart]").forEach((btn) => {

          const id = btn.getAttribute("data-product-id");
          const active = isInList(id);

          btn.classList.toggle("is-active", active);
          btn.setAttribute("aria-pressed", active ? "true" : "false");

          const labelEl = btn.querySelector(".gg-add-to-list__label");
          const defaultLabel = btn.getAttribute("data-default-label");
          const addedLabel = btn.getAttribute("data-added-label");

          if (labelEl && defaultLabel && addedLabel) {
            labelEl.textContent = active ? addedLabel : defaultLabel;
          }

        });
      }


      // Handle heart clicks anywhere on the page
      document.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-gg-heart]");
        if (!btn) return;

        e.preventDefault();

        const item = {
          id: btn.getAttribute("data-product-id"),
          handle: btn.getAttribute("data-product-handle"),
          title: btn.getAttribute("data-product-title"),
          url: btn.getAttribute("data-product-url"),
          image: btn.getAttribute("data-product-image"),
          price: btn.getAttribute("data-product-price"),
          addedAt: new Date().toISOString(),
        };

          // open the modal if it exists
        if (typeof window.ggOpenAddToOccasionModal === "function") {
          window.ggLastHeartBtn = btn;
          window.ggOpenAddToOccasionModal(item);
          return;
        }

        // fallback behaviour
        toggleItem(item);
        if (window.saveListToCustomer) {
        window.saveListToCustomer();
        }
        updateAllHeartStates();

        if (document.querySelector("[data-gg-giftlist-page]")) {
          renderGiftListPage();
        }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }
      });

        /* =========================================================
        REMOVE ITEM FROM LIST
      ========================================================= */

      document.addEventListener("click", function (e) {
        const btn = e.target.closest("[data-gg-remove]");
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const id = btn.getAttribute("data-product-id");
        if (!id) return;

        removeItem(id);
        updateAllHeartStates();

        if (document.querySelector("[data-gg-giftlist-page]")) {
          const root = document.querySelector("[data-gg-giftlist-root]");
          if (root) {
            root.innerHTML = "";
          }
          renderGiftListPage();
        }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }

        ggToast("Removed from list", "success");
      });



        function escapeHtml(str) {
          return String(str || "")
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
        }

        function moneyText(price) {
          if (!price) return "";
          return escapeHtml(price);
        }

        function renderGiftListPage() {
          const root = document.querySelector("[data-gg-giftlist-root]");
          if (!root) return;

          const items = readList();

          if (!items.length) {
            root.innerHTML = `
        <div class="gg-giftlist-empty gg-giftlist-empty--premium">
          <div class="gg-giftlist-empty__inner">
            <p class="gg-giftlist-empty__title"><strong>Start your gift ideas list</strong></p>
            <p class="gg-giftlist-empty__text">
              Browse products and tap the 
              <span class="gg-inline-heart">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 6 4 4 6.5 4c1.74 0 3.41.81 4.5 2.09C12.09 4.81 13.76 4 15.5 4 18 4 20 6 20 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.9"
                        stroke-linejoin="round"/>
                </svg>
              </span>
              to save them here.
            </p>

            <div class="gg-giftlist-empty__actions">
              <a class="gg-giftlist-cta" href="/collections/all">Start exploring</a>
            </div>
          </div>
        </div>
      `;
            return;
          }

          const cards = items
            .map((item) => {
              const img = item.image
                ? `<img class="gg-giftlist-img" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
                : `<div class="gg-giftlist-img gg-giftlist-img--placeholder"></div>`;

              return `
                <div class="gg-giftlist-card">
                  <a class="gg-giftlist-link" href="${escapeHtml(item.url)}">
                    ${img}
                    <div class="gg-giftlist-meta">
                      <div class="gg-giftlist-title">${escapeHtml(item.title)}</div>
                      ${item.price ? `<div class="gg-giftlist-price">${moneyText(item.price)}</div>` : ""}
                    </div>
                  </a>
                  <button
                    class="gg-giftlist-remove"
                    type="button"
                    data-gg-remove
                    aria-label="Remove from gift ideas"
                    data-product-id="${escapeHtml(item.id)}"
                    data-product-handle="${escapeHtml(item.handle)}"
                    data-product-title="${escapeHtml(item.title)}"
                    data-product-url="${escapeHtml(item.url)}"
                    data-product-image="${escapeHtml(item.image)}"
                    data-product-price="${escapeHtml(item.price)}"
                  >
                    Remove
                  </button>
                </div>
              `;
            })
            .join("");

          root.innerHTML = `
            <div class="gg-giftlist-grid">
              ${cards}
            </div>
          `;
        }

        // Make render available for refresh
      window.renderGiftListPage = renderGiftListPage;
      window.ggUpdateAllHeartStates = updateAllHeartStates;

        // On page load: set hearts + render list page if present
        document.addEventListener("DOMContentLoaded", function () {
          updateAllHeartStates();
          if (document.querySelector("[data-gg-giftlist-page]")) {
            renderGiftListPage();
          }
        });

        // Also update after theme sections load dynamically
        document.addEventListener("shopify:section:load", function () {
          updateAllHeartStates();
        });
      })();
      /* =========================================================
        TOAST + SAVE LIST (clean version)
      ========================================================= */

      function ggToast(message, type = "success") {
        const el =
          document.querySelector("[data-gg-save-message]") ||
          document.querySelector("[data-gg-toast]");

        if (!el) {
          console.log("TOAST:", message);
          return;
        }

        el.textContent = message;
        el.hidden = false;
        el.classList.remove("hidden");
        el.classList.remove("is-success", "is-error");

        if (type === "error") el.classList.add("is-error");
        if (type === "success") el.classList.add("is-success");

        clearTimeout(window.__GG_TOAST_TIMER__);
        window.__GG_TOAST_TIMER__ = setTimeout(() => {
          el.hidden = true;
          el.classList.add("hidden");
          el.classList.remove("is-success", "is-error");
        }, 4500);
      }

      (function () {
        if (window.__GG_GIFTLIST_SAVE_INIT__) return;
        window.__GG_GIFTLIST_SAVE_INIT__ = true;

        const STORAGE_KEY_PREFIX = "gg_giftlist_v1__";

        function safeJsonParse(text) {
          try {
            return JSON.parse(text);
          } catch (e) {
            return null;
          }
        }

        function getActiveOccasionName() {
          try {
            return (localStorage.getItem("gg_active_occasion_v1") || "My Gift Ideas").trim();
          } catch (e) {
            return "My Gift Ideas";
          }
        }

        function readActiveList() {
          try {
            const occasion = getActiveOccasionName();
            const key = STORAGE_KEY_PREFIX + occasion;
            const raw = localStorage.getItem(key);
            const items = raw ? JSON.parse(raw) : [];
            return Array.isArray(items) ? items : [];
          } catch (e) {
            return [];
          }
        }

        window.saveListToCustomer = async function () {
          console.log("Running saveListToCustomer()...");

          const activeOccasion = getActiveOccasionName();
          const items = readActiveList();

          console.log("Saving occasion:", activeOccasion);
          console.log("Items being saved:", items);

          if (!items.length) {
            ggToast("Add a few gift ideas first", "error");
            return null;
          }

          const FUNCTION_URL =
  "https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list";

const btn = document.querySelector("[data-gg-save-list]");
if (btn) {
  btn.disabled = true;
  btn.setAttribute("aria-busy", "true");
}

ggToast("Saving…");

const existingShareCode =
  localStorage.getItem(`gg_share_code__${activeOccasion}`) || "";

let remotePurchasedMap = new Map();

if (existingShareCode) {
  try {
    const existingRes = await fetch(
      `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(existingShareCode)}`,
      {
        headers: {
          apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
          Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`
        }
      }
    );

    const existingData = await existingRes.json();
    const existingPayload = existingData?.list || existingData || {};

    let existingItems = existingPayload.items || [];

    if (typeof existingItems === "string") {
      try {
        existingItems = JSON.parse(existingItems);
      } catch (e) {
        existingItems = [];
      }
    }

    remotePurchasedMap = new Map(
      (Array.isArray(existingItems) ? existingItems : []).map((item) => [
        String(item.id || ""),
        !!item.purchased
      ])
    );
  } catch (err) {
    console.log("Could not load existing list before save", err);
  }
}

const cleanItems = (items || [])
  .map((item) => ({
    id: String(item.id || ""),
    title: item.title || "",
    url: item.url || "",
    image: item.image || "",
    price: item.price || "",
    handle: item.handle || "",
    purchased:
      typeof item.purchased !== "undefined"
        ? !!item.purchased
        : !!remotePurchasedMap.get(String(item.id || ""))
  }))
  .filter((item) => item.id && item.title && item.url);

console.log("Clean items being saved:", cleanItems);

const savedMeta = (() => {
  try {
    return JSON.parse(localStorage.getItem(`gg_occasion_meta__${activeOccasion}`) || "{}");
  } catch (err) {
    return {};
  }
})();

try {
  const res = await fetch(FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
      Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
          },
    body: JSON.stringify({
      title: activeOccasion,
      event_date: savedMeta.occasion_date || null,
      occasion_type: savedMeta.occasion_type || "",
      occasion_date: savedMeta.occasion_date || null,
      items: cleanItems,
      child_name: savedMeta.child_name || null,
      child_dob: savedMeta.child_dob || null,
      child_pronoun: savedMeta.child_pronoun || "they",
      child_interests: savedMeta.child_interests || null,
      child_note: savedMeta.child_note || null
    }),
  });

  console.log("Response status:", res.status);

  const raw = await res.text();
  console.log("Raw response:", raw);

  const data = safeJsonParse(raw);

  if (!res.ok) {
  ggToast("Save failed", "error");
  return null;
}

  if (res.ok && data && (data.share_code || data.id)) {
    localStorage.setItem("gg_list_id", data.id);
    localStorage.setItem("gg_owner_token", data.owner_token || "");
    localStorage.setItem("gg_share_code", data.share_code || "");

    localStorage.setItem(`gg_list_id__${activeOccasion}`, data.id);
    localStorage.setItem(`gg_owner_token__${activeOccasion}`, data.owner_token || "");
    localStorage.setItem(`gg_share_code__${activeOccasion}`, data.share_code || "");

    console.log("Save success ✅", data);
    localStorage.setItem("gg_last_saved_items", JSON.stringify(cleanItems));
    ggToast("List saved ✓", "success");
    return data;

    if (window.ggRenderOccasionsFromStorage) {
      window.ggRenderOccasionsFromStorage();
    }

    if (typeof renderGiftListPage === "function") {
      renderGiftListPage();
    }
  } else {
  console.log("Save failed ❌", data);
  ggToast("Save failed", "error");
  return null;
}
} catch (err) {
  console.log("Save error ❌", err);
  ggToast("Save failed", "error");
  return null;
} finally {
  if (btn) {
    btn.disabled = false;
    btn.removeAttribute("aria-busy");
  }
}
        };
        

        document.addEventListener("click", function (e) {
          const btn = e.target.closest("[data-gg-save-list]");
          if (!btn) return;

          e.preventDefault();
          e.stopPropagation();

          console.log("Save list clicked ✅");
          window.saveListToCustomer();
        });
      })();
      /* =========================================================
        OCCASIONS (simple v1: create + persist + highlight)
      ========================================================= */

      const GG_OCCASIONS_KEY = "gg_occasions_v1";
      const GG_ACTIVE_OCCASION_KEY = "gg_active_occasion_v1";

      function ggCountGiftsForOccasion(name) {
        try {
          const key = "gg_giftlist_v1__" + String(name || "My Gift Ideas").trim();
          const raw = localStorage.getItem(key);
          const list = raw ? JSON.parse(raw) : [];
          return Array.isArray(list) ? list.length : 0;
        } catch (e) {
          return 0;
        }
      }
      function ggLoadOccasions() {
        try {
          const raw = localStorage.getItem(GG_OCCASIONS_KEY);
          if (!raw) return [];
          const data = JSON.parse(raw);
          return Array.isArray(data) ? data : [];
        } catch {
          return [];
        }
      }

      function ggSaveOccasions(list) {
        localStorage.setItem(GG_OCCASIONS_KEY, JSON.stringify(list));
      }

      function ggLoadActiveOccasion() {
        try {
          return localStorage.getItem(GG_ACTIVE_OCCASION_KEY) || "";
        } catch {
          return "";
        }
      }

      function ggSaveActiveOccasion(name) {
        try {
          localStorage.setItem(GG_ACTIVE_OCCASION_KEY, name);
        } catch {}
      }

      function ggEscapeHtml(str = "") {
        return String(str).replace(/[&<>"']/g, (s) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        }[s]));
      }

      function ggRenderOccasionsFromStorage() {
        console.log("Rendering occasions…");

        const row = document.querySelector("[data-gg-occasions]");
        if (!row) return;

        const active = ggLoadActiveOccasion();

        const occasions = ggLoadOccasions().sort((a, b) => {
          if (a === active) return -1;
          if (b === active) return 1;
          return 0;
        });

        row.innerHTML = "";

        occasions.forEach((name) => {
          const wrap = document.createElement("div");
          wrap.className = "gg-occasion-card-wrap";

          wrap.innerHTML = `
        <div
          class="gg-occasion-card${name === active ? " is-active" : ""}"
          role="button"
          tabindex="0"
          data-gg-occasion-select="${ggEscapeHtml(name)}"
        >
          <p class="gg-occasion-card__name">${ggEscapeHtml(name)}</p>

          <p class="gg-occasion-card__date">
            ${typeof ggGetOccasionDate === "function" ? ggGetOccasionDate(name) : ""}
          </p>

          <p class="gg-occasion-card__meta">
            ${ggCountGiftsForOccasion(name)} gift ideas
          </p>
        </div>

        <button
        type="button"
        class="gg-occasion-card__share"
        data-gg-occasion-share="${ggEscapeHtml(name)}"
      >
        Share gift ideas
      </button>


<div class="gg-occasion-card__actions" aria-hidden="true">
  <button
    type="button"
    class="gg-occasion-card__action"
    data-gg-occasion-edit="${ggEscapeHtml(name)}"
  >
    Edit
  </button>

  <button
    type="button"
    class="gg-occasion-card__action gg-occasion-card__action--delete"
    data-gg-occasion-delete="${ggEscapeHtml(name)}"
  >
    Delete
  </button>
</div>
      `;
          const selectBtn = wrap.querySelector("[data-gg-occasion-select]");

          selectBtn.addEventListener("click", (e) => {
        if (
  e.target.closest(".gg-occasion-card__share") ||
  e.target.closest(".gg-occasion-card__actions") ||
  e.target.closest("[data-gg-occasion-edit]") ||
  e.target.closest("[data-gg-occasion-delete]")
) {
  return;
}

        console.log("Clicked occasion:", name);
        ggSaveActiveOccasion(name);
        ggRenderOccasionsFromStorage();

        if (window.renderGiftListPage) window.renderGiftListPage();
      });

          row.appendChild(wrap);
        });
      }
      window.ggRenderOccasionsFromStorage = ggRenderOccasionsFromStorage;

      /* Create occasion button */
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-gg-create-occasion]");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const name = window.prompt("Occasion name (e.g. Mia’s 6th Birthday):");
  if (!name) return;

  const trimmed = name.trim();
  if (!trimmed) return;

  const occasions = ggLoadOccasions();

  if (occasions.includes(trimmed)) {
    if (typeof ggToast === "function") {
      ggToast("That occasion already exists.", "error");
    }
    return;
  }

  occasions.unshift(trimmed);
  ggSaveOccasions(occasions);
  ggSaveActiveOccasion(trimmed);

  if (!localStorage.getItem("gg_giftlist_v1__" + trimmed)) {
    localStorage.setItem("gg_giftlist_v1__" + trimmed, "[]");
  }

  ggRenderOccasionsFromStorage();

  if (typeof renderGiftListPage === "function") {
    renderGiftListPage();
  }

  if (typeof ggToast === "function") {
    ggToast(`Created ${trimmed}`, "success");
  }
});

      /* Load occasions on page load */
      document.addEventListener("DOMContentLoaded", () => {
        ggRenderOccasionsFromStorage();
      });
         /* =========================================================
      Add to Occasion Modal
    ========================================================= */

    (function () {

      let pendingItem = null;

      function ggOpenModal(item) {
        const modal = document.querySelector("[data-gg-modal]");
        const list = document.querySelector("[data-gg-modal-options]");

          if (!modal || !list) return;

          pendingItem = item;
          const createForm = document.querySelector("[data-gg-modal-create-form]");
      const createInput = document.querySelector("[data-gg-modal-create-input]");
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");

      if (createForm) createForm.hidden = true;
      if (createInput) createInput.value = "";
      if (confirmBox) confirmBox.hidden = true;

          const activeOccasion = ggLoadActiveOccasion();

      const occasions = ggLoadOccasions().sort((a, b) => {
        if (a === activeOccasion) return -1;
        if (b === activeOccasion) return 1;
        return 0;
      });

          list.innerHTML = "";

          occasions.forEach((name) => {

      const row = document.createElement("div");
      row.className = "gg-modal__option";

      row.innerHTML = `
        <button
          type="button"
          class="gg-modal__choose"
          data-gg-occasion-choose="${escapeHtml(name)}"
          aria-label="Choose ${escapeHtml(name)}"
        >
          <div class="gg-modal__option-text">
            <div class="gg-modal__option-name-row">
              <div class="gg-modal__option-name">${escapeHtml(name)}</div>
              ${name === ggLoadActiveOccasion() ? `<span class="gg-modal__option-check">✓</span>` : ""}
            </div>
            <div class="gg-modal__option-meta">${ggCountGiftsForOccasion(name)} gifts</div>
          </div>
        </button>

      `;

      const chooseBtn = row.querySelector("[data-gg-occasion-choose]");

      chooseBtn.addEventListener("click", () => {
        ggSaveActiveOccasion(name);
        ggAddItemToOccasion(item, name);
        ggCloseModal();

        document
          .querySelectorAll(`[data-gg-heart][data-product-id="${item.id}"]`)
          .forEach((heartBtn) => {
            heartBtn.classList.add("is-active");
            heartBtn.setAttribute("aria-pressed", "true");
          });
          setTimeout(() => {
    if (window.saveListToCustomer) {
      window.saveListToCustomer();
    }
  }, 500);
      });

      list.appendChild(row);

          });


          modal.hidden = false;
        }

      function ggCloseModal() {
        const modal = document.querySelector("[data-gg-modal]");
        if (!modal) return;

        const confirmBox = document.querySelector("[data-gg-modal-confirm]");
        if (confirmBox) confirmBox.hidden = true;

        modal.hidden = true;
        document.body.classList.remove("overflow-hidden");
        pendingItem = null;
      }
      window.ggOpenAddToOccasionModal = ggOpenModal;
      window.ggCloseAddToOccasionModal = ggCloseModal;

        function ggAddItemToOccasion(item, occasionName) {

          const key = "gg_giftlist_v1__" + occasionName;

          let items = [];

          try {
            const raw = localStorage.getItem(key);
            items = raw ? JSON.parse(raw) : [];
            if (!Array.isArray(items)) items = [];
          } catch {
            items = [];
          }

          const exists = items.some((x) => String(x.id) === String(item.id));

          if (!exists) items.unshift(item);

          localStorage.setItem(key, JSON.stringify(items));


          if (window.renderGiftListPage) window.renderGiftListPage();
          if (window.ggRenderOccasionsFromStorage) window.ggRenderOccasionsFromStorage();
          if (window.ggUpdateAllHeartStates) window.ggUpdateAllHeartStates();

          if (typeof ggToast === "function") {
            ggToast("Saved to " + occasionName + " ✓", "success");
          }
        }
      // Delete occasion from modal
      document.addEventListener("click", (e) => {
        const del = e.target.closest("[data-gg-occasion-delete]");
        if (!del) return;

        e.preventDefault();
        e.stopPropagation();

        const name = del.getAttribute("data-gg-occasion-delete");
        if (!name) return;

        if (!window.confirm(`Delete "${name}"? This will remove its list too.`)) return;

        const occasions = ggLoadOccasions().filter((x) => x !== name);
        ggSaveOccasions(occasions);

        localStorage.removeItem("gg_giftlist_v1__" + name);
        localStorage.removeItem("gg_share_code__" + name);
        localStorage.removeItem("gg_list_id__" + name);
        localStorage.removeItem("gg_owner_token__" + name);

        const active = ggLoadActiveOccasion();
        if (active === name) {
          const nextActive = occasions[0] || "";
          ggSaveActiveOccasion(nextActive);
        }

        ggRenderOccasionsFromStorage();

        if (typeof renderGiftListPage === "function") {
          renderGiftListPage();
        }

        if (typeof ggToast === "function") {
          ggToast(`Deleted ${name}`, "success");
        }
      });

// Share occasion card + edit occasion
document.addEventListener("click", (e) => {
  const share = e.target.closest(".gg-occasion-card__share");
  if (share) {
    e.preventDefault();
    e.stopPropagation();

    const name = share.getAttribute("data-gg-occasion-share");
    if (!name) return;

    const shareCode =
      localStorage.getItem(`gg_share_code__${name}`) ||
      localStorage.getItem("gg_share_code");

    if (!shareCode) {
      window.saveListToCustomer().then((data) => {
        const freshShareCode =
          data?.share_code ||
          localStorage.getItem(`gg_share_code__${name}`) ||
          localStorage.getItem("gg_share_code");

        if (!freshShareCode) return;

        const url = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(freshShareCode)}&occasion=${encodeURIComponent(name)}`;

        const panel = document.querySelector("[data-gg-share-panel]");
const input = document.querySelector("[data-gg-share-url]");
const nativeBtn = document.querySelector("[data-gg-native-share]");
const titleEl = document.querySelector("[data-gg-share-title]");
const textEl = document.querySelector("[data-gg-share-text]");

if (input) input.value = url;
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = !navigator.share;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(name)}`;
      });

      return;
    }

    const url = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(shareCode)}&occasion=${encodeURIComponent(name)}`;

   const panel = document.querySelector("[data-gg-share-panel]");
const input = document.querySelector("[data-gg-share-url]");
const nativeBtn = document.querySelector("[data-gg-native-share]");
const titleEl = document.querySelector("[data-gg-share-title]");
const textEl = document.querySelector("[data-gg-share-text]");

if (input) input.value = url;
navigator.clipboard.writeText(url).catch(() => {});
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = !navigator.share;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(name)}`;

    return;
  }

  try {
    const raw = localStorage.getItem(oldKey);
    if (raw) {
      localStorage.setItem(newKey, raw);
      localStorage.removeItem(oldKey);
    }
  } catch (err) {}

  const active = ggLoadActiveOccasion();
  if (active === oldName) {
    ggSaveActiveOccasion(trimmed);
  }

  ggRenderOccasionsFromStorage();
  ggCloseModal();

  if (typeof renderGiftListPage === "function") {
    renderGiftListPage();
  }

  if (typeof ggToast === "function") {
    ggToast(`Renamed to ${trimmed}`, "success");
  }
});

        // close modal
        document.addEventListener("click", (e) => {
          if (e.target.closest("[data-gg-modal-close]")) {
            ggCloseModal();
          }
        });

        document.addEventListener("click", function (e) {
  const openBtn = e.target.closest("#gg-open-create-modal");
  if (!openBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const modal = document.getElementById("gg-create-modal");
  if (!modal) return;

  modal.hidden = false;
  document.body.classList.add("overflow-hidden");
});

document.addEventListener("click", function (e) {
  const closeBtn = e.target.closest("#gg-close-create-modal");
  const backdrop = e.target === document.getElementById("gg-create-modal");

  if (!closeBtn && !backdrop) return;

  const modal = document.getElementById("gg-create-modal");
  if (!modal) return;

  modal.hidden = true;
  document.body.classList.remove("overflow-hidden");
});

      // show create occasion form
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-toggle]");
        if (!btn) return;
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");
      if (confirmBox) confirmBox.hidden = true;

        const form = document.querySelector("[data-gg-modal-create-form]");
        const input = document.querySelector("[data-gg-modal-create-input]");
        if (!form || !input) return;

        form.hidden = false;
        input.value = "";
        input.focus();
      });

      // cancel create
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-cancel]");
        if (!btn) return;

        const form = document.querySelector("[data-gg-modal-create-form]");
        if (form) form.hidden = true;
      });

      // save new occasion
      document.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-gg-modal-create-save]");
        if (!btn) return;

        const input = document.querySelector("[data-gg-modal-create-input]");
        if (!input) return;

        const name = input.value.trim();
        if (!name) return;

        const list = ggLoadOccasions();

        if (!list.includes(name)) {
          list.unshift(name);
          ggSaveOccasions(list);
        }

        ggSaveActiveOccasion(name);
        const createForm = document.querySelector("[data-gg-modal-create-form]");
      const createInput = document.querySelector("[data-gg-modal-create-input]");
      const confirmBox = document.querySelector("[data-gg-modal-confirm]");

      if (createInput) createInput.value = "";
      if (createForm) createForm.hidden = true;
      if (confirmBox) confirmBox.hidden = true;

        if (pendingItem) {
          ggAddItemToOccasion(pendingItem, name);
          ggCloseModal();
        }

        if (window.ggRenderOccasionsFromStorage) {
          window.ggRenderOccasionsFromStorage();
        }
      });

    })();
      function escapeHtml(str) {
        return String(str || "").replace(/[&<>"']/g, (s) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        }[s]));
      }

      /* =========================================================
        SHARE LIST
      ========================================================= */

      (function () {

  if (window.__GG_GIFTLIST_SHARE_INIT__) return;
  window.__GG_GIFTLIST_SHARE_INIT__ = true;

        function getShareUrl() {
          const shareCode = localStorage.getItem("gg_share_code");
          if (!shareCode) return "";

          return `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(shareCode)}`;
        } 

        async function copyShareLink() {
  const input = document.querySelector("[data-gg-share-url]");
  const shareUrl = input?.value?.trim() || getShareUrl();

          if (!shareUrl) {
            ggToast("Save your list first", "error");
            return;
          }

          try {
            await navigator.clipboard.writeText(shareUrl);
            ggToast("Share link copied ✓", "success");
          } catch (err) {
            console.log("Share copy failed ❌", err);
            ggToast("Could not copy link", "error");
          }
        }

        document.addEventListener("click", function (e) {
          const whatsappBtn = e.target.closest("[data-gg-share-whatsapp]");
if (whatsappBtn) {
  e.preventDefault();
  e.stopPropagation();

  const shareUrl = getShareUrl();
  if (!shareUrl) {
    ggToast("Save your list first", "error");
    return;
  }

  const text = encodeURIComponent(`Here are a few gift ideas I've put together: ${shareUrl}`);
  window.open(`https://wa.me/?text=${text}`, "_blank");
  return;
}
          const copyBtn = e.target.closest("[data-gg-copy-share-link]");
          if (copyBtn) {
          e.preventDefault();
          e.stopPropagation();
          copyShareLink();
          return;
          }
          const btn = e.target.closest("[data-gg-share-list]");
          if (!btn) return;

          e.preventDefault();
          e.stopPropagation();

          (async function () {
  const result = await window.saveListToCustomer();
  console.log("Share result:", result);

  if (!result || !result.share_code) {
    return;
  }

  const shareUrl = `${window.location.origin}/pages/shared-gift-list?code=${encodeURIComponent(result.share_code)}`;

  const panel = document.querySelector("[data-gg-share-panel]");
  const input = document.querySelector("[data-gg-share-url]");
  const nativeBtn = document.querySelector("[data-gg-native-share]");
  const titleEl = document.querySelector("[data-gg-share-title]");
  const textEl = document.querySelector("[data-gg-share-text]");

  if (input) input.value = shareUrl;
if (panel) panel.hidden = false;
if (nativeBtn) nativeBtn.hidden = true;
if (titleEl) titleEl.textContent = `Gift ideas for ${formatOccasionName(localStorage.getItem("gg_active_occasion_v1") || "this occasion")}`;
})();
        });
        })();

      /* =========================================================
        LOAD SHARED LIST PAGE
      ========================================================= */

      (function () {
        async function loadSharedList() {
          const root = document.querySelector("[data-gg-shared-giftlist-root]");
          if (!root) return;

          const params = new URLSearchParams(window.location.search);
          const code = params.get("code");

          if (!code) {
            root.innerHTML = "<p>No gift list found.</p>";
            return;
          }

          try {
          
          const res = await fetch(
        `https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-get-list?code=${encodeURIComponent(code)}`,
          {
          headers: {
            apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
            Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
          },
        }
      );

            const data = await res.json();

            console.log("SHARED LIST DATA:", data);
            const payload = data?.list || data || {};

let items =
  payload.items ||
  payload.products ||
  payload.list_items ||
  payload.gift_ideas ||
  payload.ideas ||
  [];

if (typeof items === "string") {
  try {
    items = JSON.parse(items);
  } catch (err) {
    items = [];
  }
}

if (!Array.isArray(items) && typeof items === "object" && items !== null) {
  items =
    items.items ||
    items.products ||
    items.list_items ||
    [];
}

if (!Array.isArray(items)) {
  items = [];
}

      const title = payload.title || "";
      const childName = payload.child_name || "";
      const childDob = payload.child_dob || "";
      const childPronoun = payload.child_pronoun || "they";
      const childInterests = payload.child_interests || "";
      const childNote = payload.child_note || "";
      const occasionDate = payload.occasion_date || payload.event_date || "";
      const occasionType = payload.occasion_type || "";

console.log("NORMALIZED PAYLOAD:", payload);
console.log("NORMALIZED ITEMS:", items);
console.log("PAYLOAD KEYS:", Object.keys(payload || {}));

          // Build shared page hero
const hero = document.querySelector("[data-gg-shared-hero]");

if (hero) {
  const name = childName?.trim() || title || "Gift ideas";
  const rawInterests = childInterests || "";
  const note = childNote || "";
  const dob = childDob;
  const pronoun = (childPronoun || "they").toLowerCase();
  const occasionDate = payload.event_date || "";

  const interestsArray = rawInterests
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);

  let interestsText = "";
  if (interestsArray.length === 1) {
    interestsText = interestsArray[0];
  } else if (interestsArray.length === 2) {
    interestsText = `${interestsArray[0]} and ${interestsArray[1]}`;
  } else if (interestsArray.length > 2) {
    interestsText = `${interestsArray.slice(0, -1).join(", ")} and ${interestsArray[interestsArray.length - 1]}`;
  }

  let subject = "They";
  let subjectContracted = "They’re";

  if (pronoun === "she") {
    subject = "She";
    subjectContracted = "She’s";
  } else if (pronoun === "he") {
    subject = "He";
    subjectContracted = "He’s";
  }

  let occasionLine = "";

  if (dob && occasionDate) {
    const birth = new Date(dob);
    const occ = new Date(occasionDate);

    let age = occ.getFullYear() - birth.getFullYear();
    const m = occ.getMonth() - birth.getMonth();

    if (m < 0 || (m === 0 && occ.getDate() < birth.getDate())) {
      age--;
    }

    const formattedDate = occ.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long"
    });

    if (occasionType && occasionType.toLowerCase() === "birthday") {
      occasionLine = `${name}’s ${age}${getOrdinal(age)} birthday • ${formattedDate}`;
    } else if (occasionType) {
      occasionLine = `${occasionType} • ${formattedDate}`;
    } else {
      occasionLine = formattedDate;
    }
  } else if (occasionType) {
    occasionLine = occasionType;
  }

  const tagsHTML = interestsArray.length
    ? `<div class="gg-shared-tags">
        ${interestsArray.map(tag => `<span class="gg-shared-tag">${tag}</span>`).join("")}
      </div>`
    : "";

  const interestsLine = interestsText
    ? `<p class="gg-shared-intro">${subjectContracted} currently really into ${interestsText}.</p>`
    : "";

  const noteLine = note
    ? `<p class="gg-shared-note"><strong>Helpful note:</strong> ${note}</p>`
    : "";

  hero.innerHTML = `
    <h1 class="gg-shared-title">${childName ? `${name}'s gift ideas` : title}</h1>
    ${occasionLine ? `<p class="gg-shared-occasion">${occasionLine}</p>` : ""}
    <p class="gg-shared-intro">
      ${childName
        ? `If you're looking for a gift for ${name}, here are a few ideas they would really love.`
        : `Here are a few gift ideas they would love.`}
    </p>
    ${interestsLine}
    ${tagsHTML}
    ${noteLine}
  `;
}

            const cards = items
        .map((item) => {
          return `
        <div class="gg-giftlist-card ${item.purchased ? "is-purchased" : ""}" data-item-id="${item.id}" data-price="${parseFloat(item.price || "0")}">
          <a class="gg-giftlist-link" href="${item.url}" target="_blank" rel="noopener noreferrer">
            <img class="gg-giftlist-img" src="${item.image}" alt="${item.title}" loading="lazy">
            <div class="gg-giftlist-meta">
              <div class="gg-giftlist-title">${item.title}</div>
              <div class="gg-giftlist-price">${item.price || ""}</div>
            </div>
          </a>

          <a class="gg-buy-btn" href="${item.url}" target="_blank" rel="noopener noreferrer">
            Buy from retailer
          </a>

          <div class="gg-purchase-actions">
            <button class="gg-purchased-btn ${item.purchased ? "is-purchased" : ""}" type="button">
              ${item.purchased ? "✓ Someone is buying this" : "I’ll buy this"}
            </button>

            <button
              class="gg-purchased-btn gg-purchased-btn--secondary ${item.purchased ? "is-purchased" : ""}"
              type="button"
              data-gg-bought-elsewhere
            >
              ${item.purchased ? "Bought elsewhere ✓" : "Bought elsewhere"}
            </button>
          </div>
        </div>
      `;
        })
        .join("");

            root.innerHTML = `<div class="gg-giftlist-grid" data-gg-shared-grid>${cards}</div>`;
            sortGiftCards();
          } catch (err) {
            console.log("Error loading shared list", err);
            root.innerHTML = "<p>Could not load gift list.</p>";
          }
        }

            function getOrdinal(n) {
        if (n % 10 === 1 && n % 100 !== 11) return "st";
        if (n % 10 === 2 && n % 100 !== 12) return "nd";
        if (n % 10 === 3 && n % 100 !== 13) return "rd";
        return "th";
      }

      function applySharedPriceFilters() {
        const activeButtons = Array.from(document.querySelectorAll(".gg-filter-btn.active"));
        const cards = document.querySelectorAll(".gg-giftlist-card");

        if (!activeButtons.length) {
          cards.forEach((card) => {
            card.style.display = "";
          });
          return;
        }

        const activeRanges = activeButtons.map((btn) => {
          const range = btn.dataset.priceFilter || "";
          const [min, max] = range.split("-").map(Number);
          return { min, max };
        });

        cards.forEach((card) => {
          const price = parseFloat(card.dataset.price || "0");

          const matchesAnyRange = activeRanges.some(({ min, max }) => {
            return price >= min && price <= max;
          });

          card.style.display = matchesAnyRange ? "" : "none";
        });
      }

      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".gg-filter-btn");
        if (!btn) return;

        btn.classList.toggle("active");
        applySharedPriceFilters();
      });

      document.addEventListener("click", function (e) {
        const clearBtn = e.target.closest(".gg-filter-clear");
        if (!clearBtn) return;

        document.querySelectorAll(".gg-filter-btn").forEach((btn) => {
          btn.classList.remove("active");
        });

        applySharedPriceFilters();
      });

      function sortGiftCards() {
  const grid = document.querySelector("[data-gg-shared-grid]");
  if (!grid) return;

  const cards = Array.from(grid.querySelectorAll(".gg-giftlist-card"));
  const select = document.querySelector("#gg-sort");

  cards.sort((a, b) => {
    if (select && select.value) {
      const priceA = parseFloat(a.dataset.price || "0");
      const priceB = parseFloat(b.dataset.price || "0");

      if (select.value === "price-low") return priceA - priceB;
      if (select.value === "price-high") return priceB - priceA;
    }

    const aPurchased = a.classList.contains("is-purchased");
    const bPurchased = b.classList.contains("is-purchased");

    if (aPurchased && !bPurchased) return 1;
    if (!aPurchased && bPurchased) return -1;

    return 0;
  });

  cards.forEach((card) => grid.appendChild(card));
      }

      document.addEventListener("change", function (e) {
        if (e.target.matches("#gg-sort")) {
          sortGiftCards();
        }
      });

      document.addEventListener("click", async function (e) {
        const primaryBtn = e.target.closest(".gg-purchased-btn:not([data-gg-bought-elsewhere])");
        const elsewhereBtn = e.target.closest("[data-gg-bought-elsewhere]");

        if (!primaryBtn && !elsewhereBtn) return;

        const clickedElsewhere = !!elsewhereBtn;
        const clickedBtn = elsewhereBtn || primaryBtn;

        const card = clickedBtn.closest(".gg-giftlist-card");
        if (!card) return;

        const itemId = card.dataset.itemId;
        const params = new URLSearchParams(window.location.search);
        const shareCode = params.get("code");

        const nextPurchased = !card.classList.contains("is-purchased");

        const primaryActionBtn = card.querySelector(".gg-purchased-btn:not([data-gg-bought-elsewhere])");
        const elsewhereActionBtn = card.querySelector("[data-gg-bought-elsewhere]");

        card.classList.toggle("is-purchased", nextPurchased);

if (primaryActionBtn) {
  primaryActionBtn.classList.toggle("is-purchased", nextPurchased);
  primaryActionBtn.textContent = nextPurchased ? "✓ Someone is buying this" : "I’ll buy this";
}

if (elsewhereActionBtn) {
  elsewhereActionBtn.classList.toggle("is-purchased", nextPurchased);
  elsewhereActionBtn.textContent = nextPurchased ? "Bought elsewhere ✓" : "Bought elsewhere";
}

        sortGiftCards();

        try {
          const res = await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-update-purchased", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              share_code: shareCode,
              item_id: itemId,
              purchased: nextPurchased
            })
          });

          if (!res.ok) {
            throw new Error("Failed to save purchased status");
          }
        } catch (err) {
          console.log("Failed to update purchased status", err);

          card.classList.toggle("is-purchased", !nextPurchased);

if (primaryActionBtn) {
  primaryActionBtn.classList.toggle("is-purchased", !nextPurchased);
  primaryActionBtn.textContent = !nextPurchased ? "✓ Someone is buying this" : "I’ll buy this";
}

if (elsewhereActionBtn) {
  elsewhereActionBtn.classList.toggle("is-purchased", !nextPurchased);
  elsewhereActionBtn.textContent = !nextPurchased ? "Bought elsewhere ✓" : "Bought elsewhere";
}

          sortGiftCards();
          alert("Sorry, that change could not be saved.");
        }
      });

      document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector("[data-gg-create-form]");

  setTimeout(() => {
  if (typeof sortGiftCards === "function") {
    sortGiftCards();
  }
}, 100);

  if (!form) return;

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    const message = document.querySelector("[data-gg-create-message]");
    if (message) {
      message.hidden = true;
      message.textContent = "";
    }

    const childName = document.querySelector("[data-child-name]")?.value?.trim() || "";
    const childDob = document.querySelector("[data-child-dob]")?.value || null;
    const childPronoun = document.querySelector("[data-child-pronoun]")?.value || "they";
    const childInterests = document.querySelector("[data-child-interests]")?.value?.trim() || "";
    const childNote = document.querySelector("[data-child-note]")?.value?.trim() || "";
    const occasionType = document.querySelector("[data-occasion-type]")?.value || "";
    const occasionDate = document.querySelector("[data-occasion-date]")?.value || null;
    let occasionTitle = document.querySelector("[data-occasion-title]")?.value?.trim() || "";

    if (!childName || !occasionType) {
      if (message) {
        message.hidden = false;
        message.textContent = "Please add a child’s name and choose an occasion.";
      }
      return;
    }

    if (!occasionTitle) {
      if (occasionType === "Birthday") {
        occasionTitle = `${childName}'s Birthday`;
      } else if (occasionType === "Christmas") {
        occasionTitle = `Christmas`;
      } else {
        occasionTitle = `${childName}'s occasion`;
      }
    }

    const occasions = ggLoadOccasions();

    if (!occasions.includes(occasionTitle)) {
      occasions.unshift(occasionTitle);
      ggSaveOccasions(occasions);
    }

    ggSaveActiveOccasion(occasionTitle);

    if (!localStorage.getItem("gg_giftlist_v1__" + occasionTitle)) {
      localStorage.setItem("gg_giftlist_v1__" + occasionTitle, "[]");
    }

    if (window.ggRenderOccasionsFromStorage) {
      window.ggRenderOccasionsFromStorage();
    }

    if (typeof renderGiftListPage === "function") {
      renderGiftListPage();
    }

    try {
      const FUNCTION_URL = "https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list";

      // ... keep the rest of your existing save code here ...
      
      const activeKey = "gg_giftlist_v1__" + occasionTitle;

let items = [];
try {
  const rawItems = localStorage.getItem(activeKey);
  items = rawItems ? JSON.parse(rawItems) : [];
  if (!Array.isArray(items)) items = [];
} catch (err) {
  items = [];
}

console.log("RAW ITEMS BEFORE CLEAN:", items);
console.log("RAW ITEM COUNT:", items?.length);

const existingPurchasedMap = new Map(
  (JSON.parse(localStorage.getItem("gg_last_saved_items") || "[]") || []).map((saved) => [
    String(saved.id || ""),
    !!saved.purchased
  ])
);

const cleanItems = items
  .map((item) => ({
    id: String(item.id || ""),
    title: item.title || "",
    url: item.url || "",
    image: item.image || "",
    price: item.price || "",
    handle: item.handle || "",
    purchased:
      typeof item.purchased !== "undefined"
        ? !!item.purchased
        : !!existingPurchasedMap.get(String(item.id || ""))
  }))
  .filter((item) => item.id && item.title && item.url);

    console.log("CLEAN ITEMS:", cleanItems);
    console.log("CLEAN ITEM COUNT:", cleanItems.length);

              console.log("CREATE FORM payload:", {
          title: occasionTitle,
          event_date: occasionDate,
          occasion_type: occasionType,
          occasion_date: occasionDate,
          items: cleanItems,
          child_name: childName,
          child_dob: childDob,
          child_pronoun: childPronoun,
          child_interests: childInterests,
          child_note: childNote
        });

        const res = await fetch("https://uxqpmqluozqnytnqhnwt.supabase.co/functions/v1/gg-create-list", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                apikey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M",
                Authorization: `Bearer ${"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cXBtcWx1b3pxbnl0bnFobnd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MDkxMDIsImV4cCI6MjA4ODE4NTEwMn0.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M"}`,
              },
              body: JSON.stringify({
                title: occasionTitle,
                event_date: occasionDate,
                occasion_type: occasionType,
                occasion_date: occasionDate,
                items: cleanItems,
                child_name: childName,
                child_dob: childDob,
                child_pronoun: childPronoun,
                child_interests: childInterests,
                child_note: childNote
              }),
            });

            const raw = await res.text();
      console.log("Create gift ideas raw response:", raw);

      let data = {};
      try {
        data = JSON.parse(raw);
      } catch (e) {
        data = {};
      }

      console.log("Create gift ideas parsed response:", data);

      if (!res.ok) {
        throw new Error(data?.error || raw || "Could not create gift ideas.");
      }

            if (!data || !data.share_code) {
              throw new Error("No share code returned.");
            }

            localStorage.setItem("gg_list_id", data.id || "");
localStorage.setItem("gg_owner_token", data.owner_token || "");
localStorage.setItem("gg_share_code", data.share_code || "");

localStorage.setItem(`gg_list_id__${occasionTitle}`, data.id || "");
localStorage.setItem(`gg_owner_token__${occasionTitle}`, data.owner_token || "");
localStorage.setItem(`gg_share_code__${occasionTitle}`, data.share_code || "");

localStorage.setItem(
  `gg_occasion_meta__${occasionTitle}`,
  JSON.stringify({
    child_name: childName,
    child_dob: childDob,
    child_pronoun: childPronoun,
    child_interests: childInterests,
    child_note: childNote,
    occasion_type: occasionType,
    occasion_date: occasionDate
  })
);

console.log("Stored occasion meta locally:", occasionTitle, {
  child_name: childName,
  child_dob: childDob,
  child_pronoun: childPronoun,
  child_interests: childInterests,
  child_note: childNote,
  occasion_type: occasionType,
  occasion_date: occasionDate
});
      const modal = document.getElementById("gg-create-modal");
      if (modal) {
        modal.hidden = true;
      }
          window.location.href = `/pages/gift-ideas`;
          } catch (err) {
        console.log("Create gift ideas failed ❌", err);
        alert("Create gift ideas failed. Open Console to see the error.");
        if (message) {
          message.hidden = false;
          message.textContent = "Sorry, something went wrong while creating your gift ideas.";
        }
      }
        });
      });

        document.addEventListener("DOMContentLoaded", loadSharedList);
      })();

      document.addEventListener("DOMContentLoaded", function () {
        const openBtn = document.getElementById("gg-open-create-modal");
        const modal = document.getElementById("gg-create-modal");
        const closeBtn = document.getElementById("gg-close-create-modal");

        if (openBtn && modal) {
          openBtn.addEventListener("click", () => {
            modal.hidden = false;
          });
        }

        if (closeBtn && modal) {
          closeBtn.addEventListener("click", () => {
            modal.hidden = true;
          });
        }

        if (modal) {
          modal.addEventListener("click", (e) => {
            if (e.target === modal) {
              modal.hidden = true;
            }
          });
        }
      });

      // Close share modal
document.addEventListener("click", function (e) {
  const panel = document.querySelector("[data-gg-share-panel]");
  if (!panel || panel.hidden) return;

  const clickedClose = e.target.closest("[data-gg-share-close]");
  const clickedInsideDialog = e.target.closest(".gg-share-modal__dialog");

  if (clickedClose) {
    panel.hidden = true;
    return;
  }

  if (!clickedInsideDialog && e.target.closest("[data-gg-share-panel]")) {
    panel.hidden = true;
  }
});

/* =========================================================
   GOOD GIFTS — UPDATE EXISTING SHARED LIST FIX
   Paste this at the very bottom of gg-giftlist.js
   ========================================================= */

(function () {
  const SUPABASE_URL =
    "https://uxqpmqluozqnytnqhnwt.supabase.co";

  const SUPABASE_ANON_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InV4cW1xbHVvenFueXRucWhud3QiLCJyb2xlIjoiYW5vbiIsImlhdCI6MTc3MjYwOTEwMiwiZXhwIjoyMDg4MTg1MTAyfQ.HF9BFtaKQOZ09mrvIgujHlatr8pSbPGDv7TbBsNrU6M";

  function getActiveOccasionName() {
    try {
      return (
        localStorage.getItem("gg_active_occasion_v1") ||
        "My Gift Ideas"
      ).trim();
    } catch (error) {
      return "My Gift Ideas";
    }
  }

  function readActiveList(activeOccasion) {
    try {
      const key = `gg_giftlist_v1__${activeOccasion}`;
      const raw = localStorage.getItem(key);
      const items = raw ? JSON.parse(raw) : [];

      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function readOccasionMeta(activeOccasion) {
    try {
      const raw = localStorage.getItem(
        `gg_occasion_meta__${activeOccasion}`
      );

      return raw ? JSON.parse(raw) : {};
    } catch (error) {
      return {};
    }
  }

  function showMessage(message, type) {
    if (typeof window.ggToast === "function") {
      window.ggToast(message, type);
    } else {
      console.log(message);
    }
  }

  /*
   * Replace the original save function.
   */
  window.saveListToCustomer = async function () {
    const activeOccasion = getActiveOccasionName();
    const items = readActiveList(activeOccasion);
    const savedMeta = readOccasionMeta(activeOccasion);

    if (!items.length) {
      showMessage("Add a few gift ideas first", "error");
      return null;
    }

    const existingListId =
      localStorage.getItem(
        `gg_list_id__${activeOccasion}`
      ) ||
      localStorage.getItem("gg_list_id") ||
      "";

    const existingOwnerToken =
      localStorage.getItem(
        `gg_owner_token__${activeOccasion}`
      ) ||
      localStorage.getItem("gg_owner_token") ||
      "";

    const existingShareCode =
      localStorage.getItem(
        `gg_share_code__${activeOccasion}`
      ) ||
      localStorage.getItem("gg_share_code") ||
      "";

    console.log("Saving existing gift list", {
      activeOccasion,
      existingListId,
      existingShareCode,
      itemCount: items.length
    });

    const button = document.querySelector(
      "[data-gg-save-list]"
    );

    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
    }

    showMessage("Saving…", "success");

    /*
     * Preserve purchased statuses from the external list.
     */
    const remotePurchasedMap = new Map();

    if (existingShareCode) {
      try {
        const existingResponse = await fetch(
          `${SUPABASE_URL}/functions/v1/gg-get-list?code=${encodeURIComponent(
            existingShareCode
          )}`,
          {
            headers: {
              apikey: SUPABASE_ANON_KEY,
              Authorization: `Bearer ${SUPABASE_ANON_KEY}`
            }
          }
        );

        if (existingResponse.ok) {
          const existingData =
            await existingResponse.json();

          const existingPayload =
            existingData?.list ||
            existingData ||
            {};

          let existingItems =
            existingPayload.items || [];

          if (typeof existingItems === "string") {
            try {
              existingItems =
                JSON.parse(existingItems);
            } catch (error) {
              existingItems = [];
            }
          }

          if (Array.isArray(existingItems)) {
            existingItems.forEach((item) => {
              remotePurchasedMap.set(
                String(item.id || ""),
                Boolean(item.purchased)
              );
            });
          }
        }
      } catch (error) {
        console.warn(
          "Could not load purchased statuses",
          error
        );
      }
    }

    const cleanItems = items
      .map((item) => ({
        id: String(item.id || ""),
        title: item.title || "",
        url: item.url || "",
        image: item.image || "",
        price: item.price || "",
        handle: item.handle || "",
        purchased:
          typeof item.purchased !== "undefined"
            ? Boolean(item.purchased)
            : Boolean(
                remotePurchasedMap.get(
                  String(item.id || "")
                )
              )
      }))
      .filter(
        (item) =>
          item.id &&
          item.title &&
          item.url
      );

    const payload = {
      list_id: existingListId || null,
      owner_token: existingOwnerToken || null,
      share_code: existingShareCode || null,

      title: activeOccasion,

      event_date:
        savedMeta.occasion_date || null,

      occasion_date:
        savedMeta.occasion_date || null,

      occasion_type:
        savedMeta.occasion_type || "",

      items: cleanItems,

      child_name:
        savedMeta.child_name || null,

      child_dob:
        savedMeta.child_dob || null,

      child_pronoun:
        savedMeta.child_pronoun || "they",

      child_interests:
        savedMeta.child_interests || null,

      child_note:
        savedMeta.child_note || null
    };

    try {
      const response = await fetch(
        `${SUPABASE_URL}/functions/v1/gg-create-list`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            apikey: SUPABASE_ANON_KEY,
            Authorization:
              `Bearer ${SUPABASE_ANON_KEY}`
          },

          body: JSON.stringify(payload)
        }
      );

      const rawResponse = await response.text();

      let result;

      try {
        result = JSON.parse(rawResponse);
      } catch (error) {
        result = null;
      }

      console.log(
        "Gift-list save response",
        response.status,
        result
      );

      if (!response.ok || !result?.share_code) {
        throw new Error(
          result?.error ||
          rawResponse ||
          "The gift list could not be saved"
        );
      }

      /*
       * Save the identifiers returned by Supabase.
       */
      localStorage.setItem(
        "gg_list_id",
        result.id || ""
      );

      localStorage.setItem(
        "gg_owner_token",
        result.owner_token || ""
      );

      localStorage.setItem(
        "gg_share_code",
        result.share_code || ""
      );

      localStorage.setItem(
        `gg_list_id__${activeOccasion}`,
        result.id || ""
      );

      localStorage.setItem(
        `gg_owner_token__${activeOccasion}`,
        result.owner_token || ""
      );

      localStorage.setItem(
        `gg_share_code__${activeOccasion}`,
        result.share_code || ""
      );

      localStorage.setItem(
        "gg_last_saved_items",
        JSON.stringify(cleanItems)
      );

      showMessage("List saved ✓", "success");

      if (
        typeof window.ggRenderOccasionsFromStorage ===
        "function"
      ) {
        window.ggRenderOccasionsFromStorage();
      }

      return result;
    } catch (error) {
      console.error(
        "Gift-list update failed",
        error
      );

      showMessage("Save failed", "error");

      return null;
    } finally {
      if (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
      }
    }
  };

  console.log(
    "Good Gifts shared-list update fix loaded"
  );
})();